// =============================
// Variables
// =============================

export const contentPaddingY = '4.5rem';
export const contentPaddingX = '2rem';
export const contentPaddingXSxga = '3.5rem';
